import { makeStyles } from '@material-ui/styles';

import { blue, neutral } from '../../../../shared/styles/colors';

export default makeStyles({
  root: {
    alignItems: 'center',
    background: neutral.white,
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'flex-end',
  },
  newChipContainer: {
    borderRadius: '0.875rem',
    backgroundColor: blue['50'],
    color: neutral.white,
    fontWeight: 600,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    position: 'absolute',
    top: '-0.75rem',
    zIndex: 1,
  },
  orderManagementActionsRoot: {
    position: 'sticky',
    gridArea: 'management',
    display: 'flex',
    flexDirection: 'column',
  },
});
